import { addProp } from "@pnp/odata";
import { _Group } from "../groups/types.js";
import { Calendar, Events } from "./types.js";
addProp(_Group, "calendar", Calendar, "calendar");
addProp(_Group, "events", Events);
//# sourceMappingURL=groups.js.map